'use client';

import { motion } from 'framer-motion';

export function getSectionMotionHeading(isFirst?: boolean) {
	return isFirst ? motion.h1 : motion.h2;
}
